import React, { useState, useEffect, useContext } from 'react';
import {Select} from '@thinkwell/react.polaris'
import { OrganizationsContext } from './contexts/yolk/Organizations'

export default function OrganizationsSelect(props) {
  const [organizations, fetchOrganizations, fetchOrganizationsState] = useContext(OrganizationsContext)

  const options = organizations.map((o) => { return {value: o.id, label: o.name} })

  return (
    <Select
      required={props.required}
      label={{singular: 'organization', plural: 'organizations'}}
      name="organization_id"
      options={options}
      fetchState={fetchOrganizationsState}
      onChange={props.onChange}
      notFoundMessage={props.notFoundMessage}
    />
  );
}
